export default __webpack_public_path__ + "static/media/img_chart_grade_C.700c13076f277d58b18201242fb1fcb3.svg";